<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-book"></i></div>
      <div>
        Enseignant et Matière
        <div class="page-title-subheading">Affectation des enseignants aux matières</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
              
                <div class="card-body">
                    <div class="d-flex justify-content-between mb-5">
                        <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Assigner des matières
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                            <button *ngIf="data.length!=0" (click)="getPdf()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Exporter en PDF</button>
                        </div>
    
                        <div class="form-group ms-auto">
                            <label for=""> <strong>Rechercher:</strong> </label>
                            <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                        </div>
                    </div>
    <p>{{data!.length}} élément(s)</p>
    <div class="table-responsive">
    <table class="table" >
        <thead class="">
            <tr>
                <th style="width: 10px;">#</th>
                <th>Nom et prénom(s)</th>
                <th>Classe</th>
                <th>Matière & Masse horaire</th>
            </tr>
        </thead>
        <tbody>
            <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'professors-courses' | paginate: {
                id:'ngxP1',
            itemsPerPage: pg.pageSize,
            currentPage: pg.p,
            totalItems: pg.total }  ">
                <td>
                    <div class="form-check mb-2">
                        <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                    
                    </div>
                </td>
                <td>{{d.professor?.lastname}} {{d.professor?.firstname}}</td>
                <td>{{d.classroom?.name}}</td>
                <td>
                    <ul>
                        <li *ngFor="let course of d.courses">
                            <div class="">
                                <span>{{course.name}} </span>
                                <span *ngIf="course.is_special">(SPE)</span>
                                <i class="fa fa-times text-danger pointer ms-1" (click)="removeCourse(course.pivot?.id)"></i>    
                            </div>
                            <br>
                            <div *ngIf="course.is_special" class="">
                                <span class="text-underline text-primary pointer" (click)="openForSpeciality(d,course.pivot.id)">Liste apprenants de spécialité</span>
                            </div>
                        </li>
                    </ul>
                </td>
            </tr>
        
        </tbody>
    </table>
    </div>
    <pagination-controls 
    id="ngxP1"
    (pageChange)="getPage($event)"
  [maxSize]="9"
  [directionLinks]="true"
  [autoHide]="true"
  [responsive]="true"
  [previousLabel]="'Previous'"
  [nextLabel]="'Next'"
  [screenReaderPaginationLabel]="'Pagination'"
  [screenReaderPageLabel]="'page'"
  [screenReaderCurrentLabel]="'You\'re on page'">
 </pagination-controls>
</div>
</div>
</div>
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer un professeur</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Enseignant <span class="text-danger ml-2">(*)</span></label>
                <select class="form-control" name="professor_id" [(ngModel)]="professor_id" (change)="loadClassrooms($event)" id="">
                    <option disabled selected></option>
                    <option *ngFor="let p of professors" [value]="p.id">{{p.lastname}} {{p.firstname}}</option>
                </select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Classe(s) gardée(s) <span class="text-danger ml-2">(*)</span></label>
                <select class="form-control" name="pac_id" ngModel id="">
                    <option *ngFor="let c of classrooms" [value]="c.id">{{c.classroom?.name}}</option>
                </select>
            </div>
             <div class=" form-group col-12 mb-3">
                <label for="">Matière <span class="text-danger ml-2">(*)</span></label>
                <select class="form-control" name="course_id" ngModel id="">
                    <option *ngFor="let c of courses" [value]="c.id">{{c.name}}</option>
                </select>
            </div>
            <!-- <div class=" form-group col-12 mb-3">
                <label for="">Masse horaire <span class="text-danger ml-2">(*)</span></label>
                <input type="number" min="1" name="hourly_weight" class="form-control" ngModel>
            </div>  -->
        </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>
  <ng-template #contentStudents let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Liste des apprenants</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
       <div *ngFor="let s of students" class="d-flex justify-content-between">
        <div class="">{{s.identity}}</div>
        <div class=""></div>
       </div>
	</div>
</ng-template>

